import { GlobalContext } from "@src/GlobalContextProvider";
import { useContext } from "react";

const useGlobalContext = () => useContext(GlobalContext);

export default useGlobalContext;
